import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, Paper, CircularProgress, List, ListItem, ListItemText, Divider, Autocomplete } from '@mui/material';
import axios from 'axios';
import { baseUrl, requestID, config } from '../../../common/utils';
import { useHistory, useLocation } from 'react-router-dom';

interface Aspirant {
  id: string;
  firstName: string;
  election_id: string;
}

interface Users {
  user_id: string;
  firstName: string;
  lastName: string;
  middleName: string;
  position_name: string;
  email: string;
}

const AddAspirant: React.FC = () => {

    const history = useHistory();
  
    const onManage = (id: string) => {
      history.push(`/folder/manage-election/${id}`, { state: { dataId: id } });
    };

    
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const positionIdFromQuery = queryParams.get('positionId');
const electionIdFromQuery = queryParams.get('electionId');

console.log('Election ID:', electionIdFromQuery);
console.log('Position ID:', positionIdFromQuery);


    
  const [form, setForm] = useState({
    election_id: '',
    aspirant_name: '',
    position_id: '',
    aspirant_user_id: '',
  });
  const [aspirants, setAspirants] = useState<Aspirant[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  const [search, setSearch] = useState<Users[]>([]);
  const [fullName, setFullName] = useState<string>('');
  const [electionName, setElectionName] = useState<string>('');
  const [positionName, setPositionName] = useState<string>('');

  // Fetch aspirants whenever election_id changes (with debounce)
  const handleElectionIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setForm(prev => ({ ...prev, election_id: value }));
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    // Set new timeout to fetch aspirants after 500ms of user stopping typing
    if (value.trim()) {
      const timeout = setTimeout(() => {
        fetchAspirants(value);
      }, 500);
      setSearchTimeout(timeout);
    } else {
      setAspirants([]);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'election_id') {
      handleElectionIdChange(e);
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  useEffect(() => {
    if (electionIdFromQuery || positionIdFromQuery) {
      const eid = electionIdFromQuery || '';
      const pid = positionIdFromQuery || '';
  
      setForm(prev => ({
        ...prev,
        election_id: eid,
        position_id: pid,
      }));
  
      if (eid) fetchAllUsers();
      if (eid) fetchAspirants(eid);
    }
  }, [electionIdFromQuery, positionIdFromQuery]);
  
  
  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  const fetchAspirants = (electionId: string) => {
    if (!electionId.trim()) {
      setAspirants([]);
      return;
    }

    setLoading(true);
    
    const formData = new FormData();
    formData.append('requestID', requestID());
    formData.append('election_id', electionId);
    formData.append('position_id', form.position_id);

    axios.post(baseUrl() + 'elections/getAspirants', formData, config)
      .then(res => {
        console.log(res);
        
        if (res.data && res.data.data) {
          setAspirants(res.data.data);
          setElectionName(res.data.data[0]?.election_name || ''); // Assuming the first aspirant has the election name
          setPositionName(res.data.data[0]?.position_name || ''); // Assuming the first aspirant has the position name
        } else {
          setAspirants([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch aspirants:', err);
        setLoading(false);
        setAspirants([]);
      });
  };

  // const fetchAllUsers = (electionId: string) => {
  //   if (!electionId.trim()) {
  //     setSearch([]);
  //     return;
  //   }

  //   setLoading(true);
    
  //   const formData = new FormData();
  //   formData.append('requestID', requestID());
   

  //   axios.post(baseUrl() + 'elections/getAllUsers', formData, config)
  //     .then(res => {
  //       console.log(res);
        
  //       if (res.data && res.data.data) {
  //         setSearch(res.data.data);
  //       } else {
  //         setSearch([]);
  //       }
  //       setLoading(false);
  //     })
  //     .catch(err => {
  //       console.error('Failed to get users:', err);
  //       setLoading(false);
  //       setSearch([]);
  //     });
  // };

  const fetchAllUsers = () => {
    if (!form.election_id?.trim()) return;
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append('requestID', requestID());
  
    axios
      .post(baseUrl() + 'elections/getAllUsers', formData, config)
      .then(res => {
        console.log(res);
        if (res.data?.data) {
          setSearch(res.data.data); // Assumes user object has a "name"
        } else {
          setSearch([]);
        }
      })
      .catch(err => {
        console.error('Failed to get users:', err);
        setSearch([]);
      })
      .finally(() => setLoading(false));
  };
  

  const handleSubmit = () => {
    if (!form.election_id.trim() || !form.aspirant_name.trim()) {
      alert('Please fill all required fields');
      return;
    }

    const formData = new FormData();
    formData.append('requestID', requestID());
    formData.append('election_id', form.election_id);
    formData.append('aspirant_name', form.aspirant_name);
    formData.append('position_id', form.position_id);
    formData.append('user_id', form.aspirant_user_id);


 /*    console.log('FormData:');
  for (const [key, value] of formData.entries()) {
    console.log(`${key}: ${value}`);
  } */
    axios.post(baseUrl() + 'elections/addAspirant', formData, config)
      .then(res => {
        alert('Aspirant added successfully');
          onManage(form.election_id);
        // setForm({ ...form, aspirant_name: '' });
        // setForm({ election_id: electionIdFromQuery || '', aspirant_name: '' });
        setForm(prev => ({ ...prev, aspirant_name: '', aspirant_user_id: '' })); // Reset only aspirant_name and aspirant_user_id
        console.log(res);
        // Refresh the aspirants list
        fetchAspirants(form.election_id);
      })
      .catch(err => {
        console.error(err);
        alert('Failed to add aspirant');
      });
  };

  return (
    <Paper sx={{ p: 3, mt: 4 }}>
      <Typography variant="h6" gutterBottom>Add Aspirant</Typography>
      
      <Box sx={{ position: 'relative' }}>
      <TextField
  label="Election ID"
  name="election_id"
  fullWidth
  margin="normal"
  value={form.election_id}
  onChange={handleChange}
  placeholder="Enter election ID to search aspirants"
  InputProps={{
    readOnly: !!electionIdFromQuery,
  }}
/>
        {loading && (
          <CircularProgress 
            size={24} 
            sx={{ 
              position: 'absolute', 
              right: 12, 
              top: '50%', 
              marginTop: '-12px' 
            }} 
          />
        )}
      </Box>
      
      {/* <TextField
        label="Aspirant Name"
        name="aspirant_name"
        fullWidth
        margin="normal"
        value={form.aspirant_name}
        onChange={handleChange}
      /> */}

<Autocomplete
  options={search}
  getOptionLabel={(option) => option.firstName} // only show firstName
  isOptionEqualToValue={(option, value) => option.user_id === value.user_id}
  loading={loading}
  onFocus={fetchAllUsers}
  onChange={(event, newValue) => {
    if (newValue) {
      setForm(prev => ({
        ...prev,
        aspirant_name: newValue.firstName,
        aspirant_user_id: newValue.user_id
      }));
    } else {
      setForm(prev => ({
        ...prev,
        aspirant_name: '',
        aspirant_user_id: ''
      }));
    }
  }}
  value={search.find(u => u.user_id === form.aspirant_user_id) || null}
  renderOption={(props, option) => (
    <li {...props} key={option.user_id}>
      {option.firstName}
    </li>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Aspirant Name"
      name="aspirant_name"
      fullWidth
      margin="normal"
    />
  )}
/>

  

      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={handleSubmit} 
        sx={{ mt: 2 }}
        disabled={!form.election_id || !form.aspirant_name || loading}
      >
        Add Aspirant
      </Button>

      {aspirants.length > 0 && (
        <Box sx={{ mt: 4 }}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" gutterBottom align="center">
            Aspirants for {electionName}
          </Typography>
          <Typography variant="h6" gutterBottom align="center">
            Position: {positionName}
          </Typography>
          <Typography variant="body1" color="textSecondary" align="left">
            {aspirants.length} aspirants found
          </Typography>


          <List>
            {aspirants.map((aspirant, index) => (
              
              <ListItem key={aspirant.id || index} divider>
                <ListItemText 
                  primary={aspirant.firstName} 
                  secondary={`ID: ${aspirant.id || 'N/A'}`}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      )}

      {!loading && aspirants.length === 0 && form.election_id && (
        <Box sx={{ mt: 4 }}>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body1" color="textSecondary" align="center">
            No aspirants found for this election.
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default AddAspirant;
